module.exports = __webpack_public_path__ + "static/demo-image-012256ab9e4165bda1cc896178d19395.png";